import Vue from 'vue';
import { Validator } from 'vee-validate';
export default function () {
  this.academicValidation = function () {
    const dictonary = {
      custom: {
        academicCode: {
          required: () => "Academic is required"
        },
        institueName: {
          required: () => "Institute Name is required"
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeAcademicValidation.js